import createAPI from './create-api'
import TLoading from './index.vue'
import Loading from './loading.vue'
import GLoading from './global-loading.vue'

function addLoading(Vue, Loading, events) {
  createAPI(Vue, Loading, events, true)
}

TLoading.install = Vue => {
  // 组件模式
  Vue.component(TLoading.name, TLoading)
  // 单例模式
  addLoading(Vue, Loading)
  addLoading(Vue, TLoading)
}

GLoading.install = Vue => {
  // 组件模式
  Vue.component(GLoading.name, GLoading)
  // 全局模式
  addLoading(Vue, GLoading)
}

export { TLoading, GLoading }



// WEBPACK FOOTER //
// ./src/module/loading/index.js